import { useNavigate } from "react-router-dom";
import "./button.css";

export default function Button({
  title,
  bgButton,
  nextPage,
  heightCode = true,
  widthCode = true,
  newOtp = false,
  setX,
  setY,
  handleClick,
  disabled = false,
}) {
  const navigate = useNavigate();
  const isActive = bgButton && !disabled;

  const goToAddressPage = () => {
    if (disabled) return;
    if (newOtp) {
      setX(60);
      setY(59);
    } else if (bgButton === true && nextPage) {
      navigate(nextPage);
    }
  };

  return (
    <div className="w-full flex justify-center items-center">
      <button
        type="button"
        disabled={disabled || !isActive}
        className={`text-large rounded-[20px] font-IRANSansBold ${
          isActive
            ? "bg-scabDarkYellow text-scabBlack"
            : "bg-scabBtnGray text-scabWhite"
        } ${heightCode ? "h-[52px]" : "h-[44px]"} ${
          widthCode ? "w-full max-w-[400px]" : "w-[180px]"
        }`}
        onClick={handleClick === undefined ? goToAddressPage : handleClick}
      >
        {title}
      </button>
    </div>
  );
}
